import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Checkbox,
  Radio,
  Input,
  Button,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardSearchPackageUX = (props: any) => {
    return(
      <div
        id="CardSearchPackageUX-div-0"
        style={{width: "100%"}}>
        <div
          id="CardSearchPackageUX-div-1"
          style={{display: props.hideTitle?"none":"flex", alignItems: "center", justifyContent: "space-between", padding: "15px 20px", backgroundColor: "#F2F2F2"}}>
          
          <div
            id="CardSearchPackageUX-div-3"
            style={{fontSize: "1.2rem", fontWeight: "bold", color: "#0072BC"}}>
            {props.languageUX === "en" ? "Find different types of packages" : "ค้นหาแพ็กเกจประเภทต่างๆ"}
          </div>
        </div>
        <div
          className="ui divider"
          id="CardSearchPackageUX-div-2"
          style={{marginTop: 0, border: "none"}}>
          
        </div>
        <div
          id="CardSearchPackageUX-div-4"
          style={{padding: "0 15px"}}>
          
          <div
            className="ui form"
            id="CardSearchPackageUX-div-5">
            
            <FormGroup
              id="CardSearchPackageUX-FormGroup-6"
              inline={true}>
              <FormField
                id="CardSearchPackageUX-FormField-54"
                inline={true}
                style={{display: props.showPackageNameFilter?"":"none"}}
                width={5}>
                <Input
                  fluid={true}
                  icon="search"
                  id="CardSearchPackageUX-Input-55"
                  name="programName"
                  onChange={props.onChangeValue}
                  onKeyDown={props.onKeyDownProgramName}
                  placeholder="ค้นหาชื่อบริการ"
                  value={props.filterPackage?.programName || ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-7"
                inline={true}>
                <Checkbox
                  checked={props.filterPackage?.isServiceType || false}
                  id="CardSearchPackageUX-Checkbox-13"
                  label={props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                  name="isServiceType"
                  onChange={props.onChangeValue}
                  style={{fontWeight: "bold", minWidth: "max-content"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-8"
                inline={true}
                width={4}>
                <Dropdown
                  clearable={true}
                  disabled={props.disabledPackageServiceType|| false}
                  fluid={true}
                  id="CardSearchPackageUX-Dropdown-42"
                  name="serviceType"
                  onChange={props.onChangeValue}
                  options={props.packageServiceTypeOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPackage?.serviceType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-9"
                inline={true}
                style={{display: props.hidePackageTypeFilter?"none":""}}>
                <Checkbox
                  checked={props.filterPackage?.isPackageType|| false}
                  id="CardSearchPackageUX-Checkbox-14"
                  label={props.languageUX === "en" ? "Package type" : "ประเภทแพ็คเกจ"}
                  name="isPackageType"
                  onChange={props.onChangeValue}
                  style={{fontWeight: "bold", minWidth: "max-content"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-10"
                inline={true}
                style={{display: props.hidePackageTypeFilter?"none":""}}
                width={4}>
                <Dropdown
                  clearable={true}
                  disabled={props.disabledPackageType || false}
                  fluid={true}
                  id="CardSearchPackageUX-Dropdown-43"
                  name="packageType"
                  onChange={props.onChangeValue}
                  options={props.packageTypeOptions|| []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterPackage?.packageType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-11"
                inline={true}
                style={{display: props.hideProgramNameFilter?"none":""}}>
                <Checkbox
                  checked={props.filterPackage?.isProgramName|| false}
                  id="CardSearchPackageUX-Checkbox-15"
                  label={props.languageUX === "en" ? "Program name" : "ชื่อโปรแกรม"}
                  name="isProgramName"
                  onChange={props.onChangeValue}
                  style={{fontWeight: "bold", minWidth: "max-content"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-12"
                inline={true}
                style={{display: props.hideProgramNameFilter?"none":""}}
                width={4}>
                <div
                  id="CardSearchPackageUX-div-18"
                  style={{width: "100%"}}>
                  {props.SearchBoxProgramName}
                </div>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-45"
                inline={true}
                style={{display: "none"}}>
                <div
                  id="CardSearchPackageUX-div-46">
                  {props.ButtonSearch}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSearchPackageUX-FormGroup-19"
              inline={true}
              style={{display: "none"}}>
              <FormField
                id="CardSearchPackageUX-FormField-20"
                inline={true}>
                <Checkbox
                  checked={props.filterPackage?.isGender || false}
                  id="CardSearchPackageUX-Checkbox-28"
                  label="เพศ "
                  name="isGender"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-21"
                inline={true}>
                <Radio
                  checked={props.filterPackage?.gender === "MALE"}
                  disabled={!props.filterPackage?.isGender}
                  id="CardSearchPackageUX-Radio-29"
                  label={props.languageUX === "en" ? "man" : "ชาย"}
                  name="gender"
                  onChange={props.onChangeValue}
                  value="MALE">
                </Radio>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-22"
                inline={true}>
                <Radio
                  checked={props.filterPackage?.gender === "FEMALE"}
                  disabled={!props.filterPackage?.isGender}
                  id="CardSearchPackageUX-Radio-30"
                  label={props.languageUX === "en" ? "female" : "หญิง"}
                  name="gender"
                  onChange={props.onChangeValue}
                  value="FEMALE">
                </Radio>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-23"
                inline={true}>
                <Checkbox
                  checked={props.filterPackage?.isAgeRange|| false}
                  id="CardSearchPackageUX-Checkbox-31"
                  label={props.languageUX === "en" ? "Age range (years)" : "ช่วงอายุ (ปี)"}
                  name="isAgeRange"
                  onChange={props.onChangeValue}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-24"
                inline={true}
                width={2}>
                <Input
                  disabled={!props.filterPackage?.isAgeRange}
                  id="CardSearchPackageUX-Input-32"
                  name="ageStart"
                  onChange={props.onChangeValue}
                  ref={props.inputRef}
                  type="number"
                  value={props.filterPackage?.ageStart|| ""}>
                </Input>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-25"
                inline={true}>
                <label
                  id="CardSearchPackageUX-label-33">
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-26"
                inline={true}
                style={{position: "relative"}}
                width={2}>
                <Input
                  disabled={!props.filterPackage?.isAgeRange}
                  id="CardSearchPackageUX-Input-34"
                  name="ageEnd"
                  onChange={props.onChangeValue}
                  ref={props.inputRef}
                  type="number"
                  value={props.filterPackage?.ageEnd|| ""}>
                </Input>
                <label
                  id="CardSearchPackageUX-label-44"
                  style={{color: "red", position: "absolute",minWidth: "max-content", top: "37px", fontSize: "0.75rem", display: props.ageRangeError ? "": "none"}}>
                  {props.languageUX === "en" ? "Age end must not be less than Age start" : "Age end ต้องไม่น้อยกว่า Age start"}
                </label>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-27"
                inline={true}>
                <div
                  id="CardSearchPackageUX-div-41">
                  {props.ButtonSearch}
                </div>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-37"
                inline={true}>
                <Button
                  color="yellow"
                  id="CardSearchPackageUX-Button-38"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardSearchPackageUX-FormGroup-48">
              <FormField
                id="CardSearchPackageUX-FormField-49"
                style={{flex:1}}>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-50"
                inline={true}>
                <div
                  id="CardSearchPackageUX-div-53">
                  {props.ButtonSearch}
                </div>
              </FormField>
              <FormField
                id="CardSearchPackageUX-FormField-51"
                inline={true}>
                <Button
                  color="yellow"
                  id="CardSearchPackageUX-Button-52"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="CardSearchPackageUX-div-39"
            style={{marginTop: "1rem"}}>
            
            <Table
              className="--rt-tbody-overflow-y-hidden"
              data={props.packageItems || []}
              headers={props.showMedicalFee       ? "รหัส,ประเภท,ชื่อแพ็กเกจ (EN),ชื่อแพ็กเกจ (TH),เพศ,ช่วงอายุ,ราคา,จำนวน,รายละเอียด,ชื้อ"       : "รหัส,ประเภท,ชื่อแพ็กเกจ (EN),ชื่อแพ็กเกจ (TH),เพศ,ช่วงอายุ,ราคา,รายละเอียด,ชื้อ"}
              id="CardSearchPackageUX-Table-40"
              keys={props.showMedicalFee       ? "code,package_type,name_en,name,genderName,ageRange,price,quantity,description,buy"       : "code,package_type,name_en,name,genderName,ageRange,price,description,buy"}
              minRows={3}
              showPagination={false}
              style={{ maxHeight: "calc(100vh - 18rem)", ...( props.isMeBilling && { maxHeight: "300px" } ) }}
              widths={props.showMedicalFee       ? "130,^140,^200,^200,85,95,100,100,100,100"       : "130,^140,^200,^200,85,95,100,100,100"}>
            </Table>
          </div>
        </div>
      </div>
    )
}


export default CardSearchPackageUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Wed Sep 23 2026 11:28:29 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideTitle?\"none\":\"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"15px 20px\", backgroundColor: \"#F2F2F2\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: 0, border: \"none\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาแพ็กเกจประเภทต่างๆ",
          "valueEN": "Find different types of packages"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 15px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-8"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hidePackageTypeFilter?\"none\":\"\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hidePackageTypeFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideProgramNameFilter?\"none\":\"\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideProgramNameFilter?\"none\":\"\"}"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Checkbox",
      "parent": 7,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.isServiceType || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Checkbox-13"
        },
        "label": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "name": {
          "type": "value",
          "value": "isServiceType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Checkbox",
      "parent": 9,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.isPackageType|| false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Checkbox-14"
        },
        "label": {
          "type": "value",
          "value": "ประเภทแพ็คเกจ",
          "valueEN": "Package type"
        },
        "name": {
          "type": "value",
          "value": "isPackageType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Checkbox",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.isProgramName|| false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Checkbox-15"
        },
        "label": {
          "type": "value",
          "value": "ชื่อโปรแกรม",
          "valueEN": "Program name"
        },
        "name": {
          "type": "value",
          "value": "isProgramName"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", minWidth: \"max-content\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxProgramName"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-24"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Checkbox",
      "parent": 20,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.isGender || false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Checkbox-28"
        },
        "label": {
          "type": "value",
          "value": "เพศ "
        },
        "name": {
          "type": "value",
          "value": "isGender"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Radio",
      "parent": 21,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.gender === \"MALE\""
        },
        "disabled": {
          "type": "code",
          "value": "!props.filterPackage?.isGender"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Radio-29"
        },
        "label": {
          "type": "value",
          "value": "ชาย",
          "valueEN": "man"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "value",
          "value": "MALE"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Radio",
      "parent": 22,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.gender === \"FEMALE\""
        },
        "disabled": {
          "type": "code",
          "value": "!props.filterPackage?.isGender"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Radio-30"
        },
        "label": {
          "type": "value",
          "value": "หญิง",
          "valueEN": "female"
        },
        "name": {
          "type": "value",
          "value": "gender"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "value": {
          "type": "value",
          "value": "FEMALE"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Checkbox",
      "parent": 23,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.filterPackage?.isAgeRange|| false"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Checkbox-31"
        },
        "label": {
          "type": "value",
          "value": "ช่วงอายุ (ปี)",
          "valueEN": "Age range (years)"
        },
        "name": {
          "type": "value",
          "value": "isAgeRange"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Input",
      "parent": 24,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterPackage?.isAgeRange"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Input-32"
        },
        "name": {
          "type": "value",
          "value": "ageStart"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.ageStart|| \"\""
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-label-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Input",
      "parent": 26,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.filterPackage?.isAgeRange"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Input-34"
        },
        "name": {
          "type": "value",
          "value": "ageEnd"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "ref": {
          "type": "code",
          "value": "props.inputRef"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.ageEnd|| \"\""
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-37"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Button",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Button-38"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 40,
      "name": "Table",
      "parent": 39,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.packageItems || []"
        },
        "headers": {
          "type": "code",
          "value": "props.showMedicalFee       ? \"รหัส,ประเภท,ชื่อแพ็กเกจ (EN),ชื่อแพ็กเกจ (TH),เพศ,ช่วงอายุ,ราคา,จำนวน,รายละเอียด,ชื้อ\"       : \"รหัส,ประเภท,ชื่อแพ็กเกจ (EN),ชื่อแพ็กเกจ (TH),เพศ,ช่วงอายุ,ราคา,รายละเอียด,ชื้อ\""
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Table-40"
        },
        "keys": {
          "type": "code",
          "value": "props.showMedicalFee       ? \"code,package_type,name_en,name,genderName,ageRange,price,quantity,description,buy\"       : \"code,package_type,name_en,name,genderName,ageRange,price,description,buy\""
        },
        "minRows": {
          "type": "code",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ maxHeight: \"calc(100vh - 18rem)\", ...( props.isMeBilling && { maxHeight: \"300px\" } ) }"
        },
        "widths": {
          "type": "code",
          "value": "props.showMedicalFee       ? \"130,^140,^200,^200,85,95,100,100,100,100\"       : \"130,^140,^200,^200,85,95,100,100,100\""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 27,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-41"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "Dropdown",
      "parent": 8,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPackageServiceType|| false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Dropdown-42"
        },
        "name": {
          "type": "value",
          "value": "serviceType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageServiceTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.serviceType || \"\""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Dropdown",
      "parent": 10,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledPackageType || false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Dropdown-43"
        },
        "name": {
          "type": "value",
          "value": "packageType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageTypeOptions|| []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.packageType || \"\""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "Age end ต้องไม่น้อยกว่า Age start",
          "valueEN": "Age end must not be less than Age start"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-label-44"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\", position: \"absolute\",minWidth: \"max-content\", top: \"37px\", fontSize: \"0.75rem\", display: props.ageRangeError ? \"\": \"none\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormGroup-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-49"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "Button",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Button-52"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 50,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-div-53"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.showPackageNameFilter?\"\":\"none\"}"
        },
        "width": {
          "type": "code",
          "value": "5"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Input",
      "parent": 54,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardSearchPackageUX-Input-55"
        },
        "name": {
          "type": "value",
          "value": "programName"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "props.onKeyDownProgramName"
        },
        "placeholder": {
          "type": "value",
          "value": "ค้นหาชื่อบริการ"
        },
        "value": {
          "type": "code",
          "value": "props.filterPackage?.programName || \"\""
        }
      },
      "seq": 55,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardSearchPackageUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
